
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M15.157 13.743L9.415 8l5.742-5.743A1 1 0 1013.743.843L8.001 6.586 2.258.843A1 1 0 00.844 2.257L6.586 8 .844 13.743a1 1 0 001.414 1.414L8 9.414l5.742 5.743a1 1 0 101.414-1.414z"}})])
          )
        }
      }
    